/* eslint-disable no-unused-vars */
import queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { renderCommunityList } from "../../../../actions/community";
import Cancle from "../../../../assets/svg/cancle";
import Search from "../../../../assets/svg/search";
import CommunityCard from "../../../../components/common/communityCard";
import { debounce } from "../../../../utils";
import { Loading } from "../../../../components/common/LoderData";

function Assosiated({ guestUser }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const parsedQuery = queryString.parse(window.location.search);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [queryParams, setQueryParams] = useState({
    search: parsedQuery?.search || "",
  });

  const searchRef = useRef();
  const args = { limit: 12 };
  const setParams = (payload, from) => {
    const params = {};
    for (const key in payload) {
      if (payload[key]) {
        params[key] = payload[key];
      }
    }

    let queryUrl = queryString.stringify(params);
    navigate(`?${queryUrl}`);
  };

  const fetchData = () => {
    dispatch(
      renderCommunityList(
        { ...args, page: page + 1, search: queryParams?.search },
        false
      )
    ).then((res) => {
      if (res?.data?.list?.length === 0) {
        setHasMore(false);
      } else setData([...data, ...res?.data?.list]);
    });
    setPage(page + 1);
  };

  const onChangeFun = (e) => {
    if (e.length >= 3 || e.length === 0)
      setQueryParams((prev) => {
        return {
          ...prev,
          search: e,
        };
      });
    setParams({ search: e });
  };

  const optimizedFn = debounce(onChangeFun);

  const randerCharityListHandler = (page = 1, limit = 12, isSearch = false) => {
    if (queryParams.search?.length < 3 && queryParams.search?.length > 0)
      return;
    let payload = {
      page,
      limit: limit,
      search: queryParams.search?.replace("-", ""),
    };

    if (
      queryParams.search?.replace("-", "").length === 9 &&
      /^\d+$/.test(queryParams.search?.replace("-", ""))
    ) {
      payload = {
        ...payload,
        taxIdSearch: queryParams.search?.replace("-", ""),
      };
      delete payload.search;
    }

    if (queryParams.search?.length) {
      searchRef.current.value = queryParams.search;
      payload = { ...payload };
    }
    dispatch(renderCommunityList(payload)).then((res) => {
      if (res?.data?.list.length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
        if (isSearch) setData(res?.data?.list);
        else setData((prev) => [...prev, ...res?.data?.list]);
      }
    });
  };
  useEffect(() => {
    randerCharityListHandler(1, args.limit, false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams.search]);

  return (
    <>
      <InfiniteScroll
        dataLength={data?.length}
        next={fetchData}
        hasMore={hasMore}
        loader={<Loading />}
      >
        <div className="communityList-search">
          <div className="community-search-formGrp">
            <span>
              <Search />
            </span>
            <input
              type="text"
              placeholder="Search Communities"
              ref={searchRef}
              onChange={(e) => optimizedFn(e.target.value)}
            />
            {queryParams.search && (
              <span
                className="cancle-cause"
                onClick={() => {
                  setQueryParams({ search: "" });
                  setParams({ search: "" });
                  searchRef.current.value = "";
                }}
              >
                <Cancle />
              </span>
            )}
          </div>
        </div>
        {data?.length ? (
          <div className="associated">
            {data?.map((community, ind) => (
              <CommunityCard
                classname={`${
                  guestUser ? "notAsociatedButton" : "associatedButton"
                }`}
                community={community}
                isAssociated={guestUser ? false : true}
                key={community?._id}
                setData={setData}
                data={data}
                page={page}
                randerCharityListHandler={randerCharityListHandler}
                limit={args?.limit}
                search={queryParams.search?.replace("-", "")}
              />
            ))}
          </div>
        ) : (
          <p className="notFound">No Community Found </p>
        )}
      </InfiniteScroll>
    </>
  );
}

export default Assosiated;
